<template>
  <div class="l-grid-item">
    <ul class="site-map">
      <li class="site-map-item">
        <a :href="travelTop[0].path">
          <span class="site-map-text">{{ travelTop[0].name }}</span>
        </a>
        <ul
          class="
            site-map-child site-map-child-list-block site-map-child-block-margin
          "
        >
          <li class="site-map-item site-map-item-heading">海外旅行</li>
          <li class="site-map-item">
            <a href="https://www.tabikobo.com/tour/">
              <span class="site-map-underline">海外ツアー</span>
            </a>
          </li>
        </ul>
        <ul class="site-map-child site-map-child-list-block">
          <li class="site-map-item site-map-item-heading">国内旅行</li>
          <li class="site-map-item">
            <a
              href="http://japanflight.tripstar.co.jp/jp/?source=tabikobo.com"
              target="_blank"
            >
              <span class="site-map-underline">航空券</span>
            </a>
          </li>
          <li class="site-map-item">
            <a
              href="https://www.rakudaclub.com/?afkey=tabikobo/"
              target="_blank"
            >
              <span class="site-map-underline">ホテル</span>
            </a>
          </li>
        </ul>
        <ul class="site-map-child site-map-child-list-block">
          <li class="site-map-item site-map-item-heading">法人のお客様</li>
          <li class="site-map-item">
            <a href="https://www.tabikobo.com/corporate/#01">
              <span class="site-map-underline">海外出張</span>
            </a>
          </li>
          <li class="site-map-item">
            <a href="https://www.tabikobo.com/corporate/#02">
              <span class="site-map-underline">団体旅行</span>
            </a>
          </li>
          <li class="site-map-item">
            <a href="https://www.tabikobo.com/corporate/#03">
              <span class="site-map-underline">インバウンド</span>
            </a>
          </li>
          <li class="site-map-item">
            <a href="https://www.tabikobo.com/corporate/#04">
              <span class="site-map-underline">学会・コンベンション</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import Menus from "@/mixins/travelMenus.js";

export default {
  mixins: [Menus],
};
</script>
